// extracted by mini-css-extract-plugin
module.exports = {"overlay":"DefaultOverlay_overlay__SwNTZ","overlayVisible":"DefaultOverlay_overlayVisible__RXvwJ"};